<template>
  <ArticlePage page="download" :content="content" show-mobile-download />
</template>

<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/download.js';

export default {
  name: 'Download',
  components: { ArticlePage },
  data() {
    return { content };
  },
};
</script>
